import {useTranslation} from '@/translations/i18n'
import type {AgendaEventSubstitution as AgendaEventSubstitutionType} from '@/features/agenda/hooks/useAgendaAppointmentEventData'
import {StyledAgendaEventSubstitutionBadge} from '@/features/agenda/components/agenda-event-substitution/style'
import {SwitchHorizontal01Icon} from '@/components/ui/icon/Icon'

interface AgendaEventSubstitutionProps {
    substitutions: AgendaEventSubstitutionType[]
}

/**
 * Badges shown on top of the agenda event cards to make registered substitutions visible:
 * a swap icon followed by the counterpart's name. The full sentence ("replaced by X" for a
 * replaced consultant, "covering for X" for the substitute) is kept as native tooltip.
 */
export const AgendaEventSubstitution = ({substitutions}: AgendaEventSubstitutionProps) => {
    const {t} = useTranslation()

    if (substitutions.length == 0) return null

    return (
        <>
            {substitutions.map((substitution, index) => (
                <StyledAgendaEventSubstitutionBadge
                    key={index}
                    variant="neutral"
                    size="sm"
                    shape="rectangle"
                    title={
                        substitution.type == 'replaced'
                            ? t('agenda:substitute_replaced_by', {name: substitution.counterpartFullName})
                            : t('agenda:substitute_covering', {name: substitution.counterpartFullName})
                    }
                >
                    <SwitchHorizontal01Icon size={12} className="custom" />
                    <span>{substitution.counterpartFullName}</span>
                </StyledAgendaEventSubstitutionBadge>
            ))}
        </>
    )
}
